import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { listProxyApplications } from "../clients/FixieApiClient";
import { ProxyApplicationListItem } from "../models";
import { Box, LinearProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { trackConversionEvent } from "../utils/trackEvent";

export default () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const stripeCheckoutSessionId = searchParams.get('session_id') || '';

  if (!stripeCheckoutSessionId) {
    navigate("/apps");
  }

  useEffect(() => {
    const fetchProxyData = async () => {
      const response = await listProxyApplications(true, stripeCheckoutSessionId);
      if (response.ok) {
        const results: Array<ProxyApplicationListItem> = await response.json();
        if (results.length !== 1) {
          return;
        }
        const proxyApplication = results[0];
        trackConversionEvent('create_proxy_application', proxyApplication);
        toast.success(`Created ${proxyApplication.name}`, { toastId: 'proxy-created' });
        clearInterval(intervalId);
        navigate("/apps");
      }
    };

    fetchProxyData();

    // Start polling
    const intervalId = setInterval(() => {
      fetchProxyData();
    }, 2000);

    // Cleanup function to clear the interval when component unmounts
    return () => clearInterval(intervalId);
  }, [stripeCheckoutSessionId, navigate]);

  return (
    <Box sx={{ p: 4 }} textAlign="center">
      <Typography variant="h4">Creating your proxy application</Typography>
      <LinearProgress sx={{ my: 4 }} />
      <Typography variant="body2" color="#bbb">Session ID: {stripeCheckoutSessionId}</Typography>
    </Box>
  );
};
